import ie from './ie';

export default (function () {
  const ieVersion = ie();
  return ieVersion && ieVersion < 10;
}());

